/**
 * Matricule format, mirrored from src/users/matricule.format.ts (the server
 * is the one that assigns it; this is only used to show what it will be).
 *
 *   Staff:  PR + department code + joining year (2 digits) + '-' + 5-digit number   PRQM26-00001
 *   Intern: PR-INTERN- + department code + joining year + '-' + 5-digit number      PR-INTERN-QM26-00001
 */

export const DEPARTMENT_CODE_LENGTH = 2;

/** What the admin types becomes a clean code: letters only, upper case, 2 characters. */
export const cleanDepartmentCode = (value) =>
  String(value || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, DEPARTMENT_CODE_LENGTH);

/** A code proposal for a new department: initials of the first two words, else the first two letters. */
export const suggestDepartmentCode = (name) => {
  const words = String(name || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .split(/[^A-Z]+/)
    .filter((word) => word.length > 1 || /[A-Z]/.test(word));
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].slice(0, DEPARTMENT_CODE_LENGTH);
  return (words[0][0] + words[1][0]).slice(0, DEPARTMENT_CODE_LENGTH);
};

export const formatMatricule = ({ format, code, isIntern, year, number }) => {
  const prefix = format?.prefix || 'PR';
  const head = isIntern ? `${prefix}-${format?.internTag || 'INTERN'}-` : prefix;
  const yy = String(year % 100).padStart(2, '0');
  return `${head}${code}${yy}-${String(number).padStart(format?.sequenceDigits || 5, '0')}`;
};

/** The matricule a new user is about to receive, with a hint for the admin. */
export const previewMatricule = ({ format, department, isIntern, joiningDate }) => {
  if (!department) return { value: '', hint: 'Select a department to see the matricule' };
  if (!department.code) {
    return { value: '', hint: `"${department.name}" has no matricule code yet: set it in the Departments page` };
  }
  const typedYear = parseInt(String(joiningDate || '').slice(0, 4), 10);
  const year = typedYear >= 1900 ? typedYear : new Date().getFullYear();
  const number = (isIntern ? format?.nextInternNumber : format?.nextStaffNumber) || 1;
  return {
    value: formatMatricule({ format, code: department.code, isIntern, year, number }),
    hint: 'Assigned automatically when the user is saved',
  };
};
